import React, { useState } from "react";
import clowds from "./images/clowds.png";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import "flowbite";
import Signinoption from "./Signinoption";

const Navbar = () => {
  const [nav, setNav] = useState(true);
  const [showSigninpop, setShowSigninpop] = useState(false);

  return (
    <>
      <div className="lg:px-28 px-4 py-5 flex bg-[#212445] justify-between gap-2 w-full mx-auto  ">
        <div className="flex gap-10">
          <img src={clowds} className="h-8 my-auto" />
          <div className="relative text-gray-600 my-auto ">
            <input
              type="search"
              name="search"
              placeholder="Search items"
              className="bg-[#2B3056] hidden lg:block h-10 px-5 lg:pr-20 w-full mx-auto md:pr-10  rounded-full text-sm focus:outline-none"
            />
          </div>
        </div>
        <div className="flex gap-4 my-auto relative z-30">
          <div className="hidden lg:block">
            <button
            onClick={()=>{showSigninpop? setShowSigninpop(false):setShowSigninpop(true) }}
              // data-modal-target="option-modal"
              // data-modal-toggle="option-modal"
              className="py-2 flex px-4  rounded-3xl opacity-[90%] bg-transparent text-white font-semibold gap-4"
            >
              Login
            </button>
          </div>

          {/* <div className="  px-5 text-white hidden lg:block  gap-4">
            <ConnectButton className="" />
          </div> */}

          <div
            onClick={() => setNav(!nav)}
            className="block lg:hidden cursor-pointe my-auto relative z-50 cursor-pointer"
          >
            <AiOutlineMenu  size={20} color="white" />
          </div>
        </div>

        <div
          className={
            !nav
              ? "fixed left-0 z-50 top-0 w-[78%] lg:hidden block border-r h-full bg-[#212445] text-white ease-in-out duration-500"
              : "fixed left-[-400%]"
          }
        >
          <div className="p-4 lg:hidden block cursor-pointer">
            <AiOutlineClose
              size={20}
              onClick={() => setNav(!nav)}
              className="ml-auto"
            />
            <img src={clowds} className="h-6" />
            <h1 className="my-6 text-sm">
              Discover the most outstanding articles on all topics of life.
              Write your stories and share them
            </h1>

            <div
                        onClick={()=>{showSigninpop? setShowSigninpop(false):setShowSigninpop(true) }}

              // data-modal-target="option-modal"
              // data-modal-toggle="option-modal"
              className="cursor-pointer w-full bg-transaprent rounded-full p-2 hover:bg-white hover:text-black my-10"
            >
              login
            </div>
            
            <div className="flex gap-2 justify-between">
              <button className="  px-6 py-2 text-white border border-gray-300 rounded-3xl bg-[#2F47FA] font-semibold ">
                Create
              </button>
              {/* <button className="  px-6 opacity-[70%] py-2 text-white border border-gray-300 rounded-3xl bg-transparent font-semibold ">
                <ConnectButton className="" />
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <div className="z-50">

      {showSigninpop ? <Signinoption modalSigninClose = {()=>showSigninpop? setShowSigninpop(false):setShowSigninpop(true) }/> :("")} 
      </div>

    </>
  );
};

export default Navbar;
